export function searchResults(selector) {
    const input_field = selector.querySelector('input')
    const result_list = selector.querySelector('.search-input-results')
    const json_path = input_field.dataset.searchurl
    const all_results_url = input_field.dataset.searchresultsurl
    const all_results_label = input_field.dataset.searchresultslabel

    if (result_list) {
        input_field.addEventListener('keyup', () => {
            if (input_field.value.length >= 3) {
                const json = new XMLHttpRequest()
                json.onload = function () {
                    const response = JSON.parse(this.responseText)
                    const results = response.results
                    if (results.length > 0) {
                        let content = '<ul>'
                        results.forEach((item) => {
                            content +=
                                '<li>' +
                                '<a href="' +
                                item.url +
                                '">' +
                                '<strong>' +
                                item.title +
                                '</strong><br>' +
                                item.type +
                                '</a></li>'
                        })
                        if (all_results_label && all_results_url) {
                            result_list.innerHTML =
                                content +
                                '<li>' +
                                '<a href="' +
                                all_results_url +
                                '?searchInput=' +
                                input_field.value +
                                '">' +
                                '<strong>' +
                                all_results_label +
                                '</strong> <span class="icon icon-chevron-right"></span>' +
                                '</a></li></ul>'
                        } else {
                            result_list.innerHTML = content
                        }
                    }
                }
                json.open('GET', json_path + '?q=' + input_field.value)
                json.send()
            }
        })
    }
}
